import { Toaster } from 'react-hot-toast';

export const ToasterProvider = () => (
    <Toaster
        position="top-right"
        gutter={10}
        containerStyle={{
            top: 16,
            right: 16,
        }}
        toastOptions={{
            duration: 4000,
            className: 'cfamex-toast',
            style: {
                maxWidth: '22rem',
                padding: '12px 14px',
                borderRadius: '12px',
                border: '1px solid rgba(226, 232, 240, 0.9)',
                boxShadow: '0 10px 25px -8px rgba(15, 23, 42, 0.18)',
                color: '#0f172a',
                fontSize: '0.875rem',
                lineHeight: '1.35',
            },
            success: {
                iconTheme: {
                    primary: '#059669',
                    secondary: '#ecfdf5',
                },
            },
            error: {
                iconTheme: {
                    primary: '#e11d48',
                    secondary: '#fff1f2',
                },
            },
        }}
    />
);
